/* eslint-disable import/prefer-default-export */
import React, { ReactElement } from 'react';
import { ParentRecordState } from '../../../record-editor';
import { PickerItemHandler } from '../helpers/editor-fields-helper';
import RecordPickerItem from './record-picker-item';

const ALLOW_MULTIPLE_SELECTION = false;

export const recordPickerItemHandler = (): PickerItemHandler => ({
  view: (record: Record<string, any>): ReactElement => (<RecordPickerItem record={record} />),
  // @ts-ignore
  selectionHandler: (
    records: Record<string, any>[],
    selectedTaskIDs: any[],
    parentRecordState: ParentRecordState,
  ) => ({
    selectedTaskIDs,
    newParentRecordState: {
      ...parentRecordState,
      allowMultiple: ALLOW_MULTIPLE_SELECTION,
    },
  }),
  recordLinkedTitle: 'Linked Record',
  selectorTitle: 'Select Record',
  allowMultiple: ALLOW_MULTIPLE_SELECTION,
});
